import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 0 0;
    color: ${({ theme }) => theme.colors.white};
    line-height: ${rem(24)};
`;

export const TabsBorderBottom = styled.div`
    height: ${rem(2)};
    background: ${({ theme }) => theme.colors.secondaryGrey};
    width: 100%;
    position: absolute;
    bottom: 0;
`;

export const Tabs = styled.div`
    display: flex;
    flex-direction: row;
    overflow: scroll;
    scrollbar-width: none;
    padding: ${rem(20)} 0 0 0;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Tab = styled.div`
    cursor: pointer;
    height: auto;
    color: ${({ theme }) => theme.colors.grey};
    padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
    line-height: ${rem(24)};

    &.selected {
        color: ${({ theme }) => theme.colors.primary};
        border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    }
`;

export const PlayerWrapper = styled.div`
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    border: 2px solid ${({ theme }) => theme.colors.darkLight};

    &.viewer {
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.75);
        width: 100vw;
        height: 100vh;
        z-index: 999999999;
    }

    iframe {
        border: none;
    }
`;


export const Player = styled.iframe`
    width: 100%;
    min-height: ${rem(500)};
    &.viewer {
        width: 90%;
        height: 90%;
        margin: 2.5% 5%;
    }
`;

export const PlayerCloseButton = styled.button`
    background: none;
    padding: 0;
    border: none;
    cursor: pointer;
    color: white;
    top: ${rem(20)};
    right: ${rem(30)};
    position: fixed;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    z-index: 999999999;
`;

export const OpenViewerButton = styled.button`
    background: ${({ theme }) => theme.colors.black};
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    padding: ${rem(12)};
    border-radius: ${rem(6)};
    margin: 0 auto;
    display: none;

    &:hover {
        opacity: 0.9;
    }

    @media (min-width: ${breakpoints.sm}px) {
        display: block;
    }
`;

export const NoLoggedIn = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    color: ${({ theme }) => theme.colors.black};
    padding: ${rem(60)} ${rem(30)};
    height: ${rem(350)};
    text-align: center;
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const Zoom = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    color: ${({ theme }) => theme.colors.black};
    padding: ${rem(60)} ${rem(30)};
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    height: ${rem(350)};
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;



export const Message = styled.p`
    margin-bottom: ${rem(40)};
`;
